<template>
  <GamDialog ref="dialog" hide-back>
    <div class="offline-dialog" :class="{ mobile: isMobile }">
      <div class="message">
        <p>You are offline.</p>
      </div>
    </div>
  </GamDialog>
</template>

<script setup lang="ts">
import { isMobile } from '@/core/helpers/ui.helper';
import { useAppStore } from '@/stores/app.store';
import { storeToRefs } from 'pinia';
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import GamDialog from './components/gam-dialog/GamDialog.vue';

const appStore = useAppStore();
const { isOnline } = storeToRefs(appStore);
const route = useRoute();

const dialog = ref<InstanceType<typeof GamDialog>>();

onMounted(() => {
  dialog.value?.show();
  nextTick(() => {
    const dialogEl = dialog.value?.$el as HTMLDialogElement | undefined;
    dialogEl?.addEventListener('click', (e: MouseEvent) => {
      if (e.target === dialogEl) {
        dialog.value?.close();
      }
    });
  });
});

watch(isOnline, (isOnline, wasOnline) => {
  if (!wasOnline && isOnline) {
    setTimeout(() => (window.location.href = cleanRoute.value), 5000);
  }
});

const cleanRoute = computed(() => {
  const newQuery = { ...route.query };

  if (route.query.location) {
    newQuery.spot = route.query.location;
  }
  delete newQuery.side_panel;

  // @ts-ignore
  const searchParams = new URLSearchParams(newQuery).toString();

  return route.path + (searchParams ? `?${searchParams}` : '');
});
</script>

<style lang="scss" scoped>
.offline-dialog {
  display: flex;
  position: relative;
  width: calc(335px - 2 * var(--spacing-menu));
  flex-direction: column;
  justify-content: center;
  text-align: center;

  &.mobile {
    width: 100%;
    min-width: 0;
  }

  p {
    line-height: 1.4;
    opacity: 0.7;
    margin: 0;
  }
}
</style>

<style lang="scss">
.gam-dialog:has(.offline-dialog) .gam-dialog-content {
  padding: var(--spacing-l) var(--spacing-xl);
}
</style>
